import React from 'react';
import { Radio, Stack } from '@mantine/core';
import MediaSourceField from '../../../puck/fields/MediaSourceField';
import { useSelectedItemProps } from '../../../puck/fields/useSelectedItemProps';
import { isMediaPresent } from '../../../media';
import { PuckColorFieldWithPalette } from '../../../puck/fields/createPuckColorField';
import { OpacityInput } from '../../../puck/fields/puckOpacityField';
import InspectorRow from '../../../puck/fields/InspectorRow';
import { DEFAULT_BACKGROUND_OVERLAY_OPACITY } from './ProposalSection';

/**
 * Champ « Média de fond » du Bloc : la source, puis son cadrage seulement quand
 * un média est posé — un réglage d'affichage sans média n'affiche rien.
 *
 * Ancré sur `backgroundMedia` ; `mediaFit` et le voile sont des props sœurs,
 * écrites par dispatch (le onChange d'un champ Puck ne couvre que sa propre prop).
 */
export default function SectionBackgroundMediaField({ value, onChange }) {
  const { itemProps, updateItemProps } = useSelectedItemProps();

  return (
    <Stack gap="sm">
      <MediaSourceField value={value} onChange={onChange} fieldLabel="Média de fond" mediaFit={itemProps.mediaFit} />
      {isMediaPresent(value) && (
        <Radio.Group
          size="sm"
          label="Cadrage du média"
          value={itemProps.mediaFit || 'cover'}
          onChange={(mediaFit) => updateItemProps({ mediaFit })}
        >
          <Stack gap={4} mt={4}>
            <Radio value="cover" label="Remplir (recadrer)" />
            <Radio value="contain" label="Contenir (ajuster)" />
          </Stack>
        </Radio.Group>
      )}
      {isMediaPresent(value) && (
        <InspectorRow label="Voile">
          <PuckColorFieldWithPalette
            label={null}
            value={itemProps.backgroundOverlayColor || ''}
            onChange={(backgroundOverlayColor) => updateItemProps({ backgroundOverlayColor })}
            allowTransparent
          />
        </InspectorRow>
      )}
      {isMediaPresent(value) && itemProps.backgroundOverlayColor && (
        <OpacityInput
          label="Opacité du voile"
          value={itemProps.backgroundOverlayOpacity ?? DEFAULT_BACKGROUND_OVERLAY_OPACITY}
          onChange={(backgroundOverlayOpacity) => updateItemProps({ backgroundOverlayOpacity })}
        />
      )}
    </Stack>
  );
}
